import request from '@/util/bpmRequest'


/**
 * 获取列表
 */
export function list(params) {
  return request({
    url: '/procDef/list',
    method: 'post',
    params
  })
}
/**
 * 获取列表
 */
export function listProcessByServiceName(params) {
  return request({
    url: '/procDef/listProcessByServiceName',
    method: 'post',
    params
  })
}
/**
 * 分页获取列表
 */
export function listPage(params) {
  return request({
    url: '/procDef/listPage',
    method: 'post',
    params
  })
}
/**
 * 删除流程定义
 */
export function deleteByProcDefId(params) {
  return request({
    url: '/procDef/deleteByProcDefId',
    method: 'post',
    params
  })
}

/**
 * 删除流程定义
 */
export function update(data) {
  return request({
    url: '/procDef/update',
    method: 'post',
    data
  })
}


/**
 * 获取流程定义
 */
export function getProcessDefByParams(key, id, data) {
  return request({
    url: '/procDef/getProcessDefByParams?processDefKey=' + key + '&procInstId=' + id,
    method: 'post',
    data
  })
}

/**
 * 获取流程定义
 */
export function getProcessDef(key) {
  return request({
    url: '/procDef/getProcessDef?processDefKey' + key,
    method: 'post',
    data: null
  })
}

/**
 * 流程类别列表+待办数量接口
 */
export function listProcessDefWithCount(params) {
  return request({
    url: '/procDef/listProcessDefWithCount',
    method: 'post',
    params
  })
}


/**
 * 流程类别列表接口
 */
export function listProcessDef(params) {
  return request({
    url: '/procDef/listProcessDef',
    method: 'post',
    params
  })
}